import React from "react"
import SEO from "../components/seo"
import Hero from "../components/hero"
import Services from "../components/services"
import About from "../components/about"
import Contact from "../components/contact"

export default function Home() {
  return (
    <div>
      <SEO
        title="Freelance Web Developer | WordPress, Shopify & PHP"
        description="Hire a freelance web developer for WordPress and Shopify theme development, ExpressionEngine support, PHP applications, website management and web project consultancy."
      />
      <Hero />
      <Services />
      <About />
      <Contact />
    </div>
  )
}
